import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AgileFileDownloadRequest } from '../model/agile-file-download-request';
import { AgileFileDownloadResponse } from '../model/agile-file-download-response';
import { AgileFileUploadRequest } from '../model/agile-file-upload-request';
import { AgileFileUploadResponse } from '../model/agile-file-upload-response';
import { FileTypeCodeInfo } from '../model/file-type-code-info.model';
import { OSLangResponse } from '../model/oslang-response';
import { PartOSLangRequest } from '../model/part-oslang-request';
import { UserPrivilegeInfo } from '../model/user-privilege-info';
import { UserSessionInfo } from '../model/user-session-info';

import { AgileFileDeleteRequest } from '../model/agile-file-delete-request';
import { AgileFileDeleteResponse } from '../model/agile-file-delete-response';
import { AgileReplaceFileRequest } from '../model/agile-replace-file-request';
import { AgileReplaceFileResponse } from '../model/agile-replace-file-response';
import { FileCacheWARequest } from '../model/file-cache-warequest';
import { FileCacheWAResponse } from '../model/file-cache-waresponse';
import { retry } from 'rxjs/operators';
import { HardwareRelationshipUpdateRequest } from '../model/hardware-relationship-update-request';
import { ItemInfoModel } from '../model/item-info-model';
import { PartAttachmentInfoResponse } from '../model/part-attachment-info-response';
import { environment } from 'src/environments/environment';
import { URLParams } from '../model/urlparams';

@Injectable({
  providedIn: 'root'
})
export class AgileSDKService {

  aglAPIs = environment.agileAPIs;
  constructor(private http:HttpClient) { }

  urlParams:URLParams;
  setUrlParms(urlParams:URLParams){
    this.urlParams = urlParams;
  }

  getOSLangValues(partNumber:string)
  {
    const headers = { 'content-type': 'application/json'}
    return this.http.get<OSLangResponse>(this.aglAPIs.OSLangInfo.getRequest,{'headers':headers,withCredentials:true, params: {partNumber:partNumber,userName:this.urlParams.userName}}).pipe(retry(3));
  }

  postOSLangValues(partOsLangReq:PartOSLangRequest)
  {
    const headers = { 'content-type': 'application/json'}
    return this.http.post<boolean>(this.aglAPIs.OSLangUpdate.postRequest,partOsLangReq,{'headers':headers,withCredentials:true});
  }

  // getItemAttachments(itemNumber:string,itemRevision:string)
  // {
  //   let params:URLSearchParams = new URLSearchParams();
  //   params.set('itemnumber',itemNumber);
  //   params.set('itemrev',itemRevision);

  //   console.log('With Creds ')
  //   return this.http.get<PartAttachmentInfo[]>(aglAPIs.agileItemAttachments.getRequest,{withCredentials:true,
  //     params:
  //     {
  //       itemnumber:itemNumber,
  //       itemrev:itemRevision
  //     }
  //   }).pipe(retry(3));
  // }

  getItemAttachments(itemNumber:string,itemRevision:string)
  {
    let params:URLSearchParams = new URLSearchParams();
    params.set('itemnumber',itemNumber);
    params.set('itemrev',itemRevision);

    console.log('With Creds ')
    return this.http.get<PartAttachmentInfoResponse>(this.aglAPIs.agileItemAttachments.getRequest,{withCredentials:true,
      params:
      {
        itemnumber:itemNumber,
        itemrev:itemRevision,
        userName:this.urlParams.userName,
        changeNumber:this.urlParams.changeNumber,
      }
    }).pipe(retry(3));
  }
  getFileTypeCodesDropDown()
  {
    return this.http.get<FileTypeCodeInfo[]>(this.aglAPIs.fileTypeCodes.getRequest,{responseType:'json',withCredentials:true,params:{userName:this.urlParams.userName}}).pipe(retry(3));
  }

  getUserSessionInfo(partNumber:string,userName:string)
  {
    return this.http.get<UserSessionInfo>(this.aglAPIs.getUserSessionInfo.getRequest,{responseType:'json',withCredentials:true,params:{
      itemNumber:partNumber,
      userName:userName
    }}).pipe(retry(3));
  }


  getAgileSessionInfo()
  {
    const headers = new HttpHeaders().set('Access-Control-Allow-Credentials','true');
    return this.http.get<boolean>(this.aglAPIs.validateAgileSession.getRequest,{responseType:'json',withCredentials:true,'headers':headers, params:{
      userName:this.urlParams.userName
    }}).pipe(retry(3));
  }

  getUserPrivilegeInfo(partNumber:string,partRev:string,partClass:string,userName:string,userLocation:string,changeNumber:string)
  {
    console.log('url in get privilege info ',this.aglAPIs.getUserPrivilegeInfo.getRequest);
    return this.http.get<UserPrivilegeInfo>(this.aglAPIs.getUserPrivilegeInfo.getRequest,{responseType:'json',withCredentials:true,params:{
      partNumber:partNumber,
      partRev:partRev,
      partClass:partClass,
      userName:userName,
      changeNumber:changeNumber,
      userLocation:userLocation
    }}).pipe(retry(3));
  }

  uploadFileToAgileFromServer(agileFileUploadReq:AgileFileUploadRequest)
  {
    const headers = { 'content-type': 'application/json'}
    agileFileUploadReq.userName = this.urlParams.userName;
    agileFileUploadReq.changeNumber = this.urlParams.changeNumber;
    return this.http.post<AgileFileUploadResponse>(this.aglAPIs.AgileUploadFromServer.postRequest,agileFileUploadReq,{'headers':headers,withCredentials:true});
  }

  downloadFileToUNC(agileFileDownloadReq:AgileFileDownloadRequest)
  {
    const headers = { 'content-type': 'application/json'}
    agileFileDownloadReq.userName = this.urlParams.userName;
    agileFileDownloadReq.changeNumber = this.urlParams.changeNumber;
    return this.http.post<AgileFileDownloadResponse>(this.aglAPIs.AgileDownloadToUNC.postRequest,agileFileDownloadReq,{'headers':headers,withCredentials:true}).pipe(retry(3));
  }

  downloadZipFileByteResponse(agileFileDownloadReq:AgileFileDownloadRequest)
  {
    const headers = { 'content-type': 'application/json'}
    agileFileDownloadReq.userName = this.urlParams.userName;
    agileFileDownloadReq.changeNumber = this.urlParams.changeNumber;
    // return this.http.post(aglLocalAPIs.downloadZipFIleService.postRequest,agileFileDownloadReq,{'headers':headers,'responseType':'blob'});
    return this.http.post(this.aglAPIs.downloadZipFIleService.postRequest,agileFileDownloadReq,{'headers':headers,'responseType':'blob',withCredentials:true}).pipe(retry(3));

  }


  deleteFileFromSWB(agileFileDeleteReq:AgileFileDeleteRequest){
    // AgileFileDelete
    const headers = { 'content-type': 'application/json'}
    agileFileDeleteReq.userName = this.urlParams.userName;
    agileFileDeleteReq.changeNumber = this.urlParams.changeNumber;
    console.log('Delete File Request ',agileFileDeleteReq)
    return this.http.post<AgileFileDeleteResponse>(this.aglAPIs.AgileFileDelete.postRequest,agileFileDeleteReq,{'headers':headers,withCredentials:true}).pipe(retry(3));
  }



  replaceAgileFile(agileReplaceFileReq:AgileReplaceFileRequest){
    const headers = { 'content-type': 'application/json'}
    agileReplaceFileReq.userName = this.urlParams.userName;
    agileReplaceFileReq.changeNumber = this.urlParams.changeNumber;
    return this.http.post<AgileReplaceFileResponse>(this.aglAPIs.AgileFileReplace.postRequest,agileReplaceFileReq,{'headers':headers,withCredentials:true});
  }

  fileCacheWithoutAcceleration(fileCacheReq:FileCacheWARequest){

    // const headers = { 'content-type': 'multipart/form-data; boundary=<calculated when request is sent>'}
    const formData = new FormData();
    console.log('file ',fileCacheReq.file)
    formData.append('file',fileCacheReq.file);
    formData.append('fileName',fileCacheReq.fileName);
    formData.append('filePath',fileCacheReq.filePath);
    formData.append('userName',fileCacheReq.userName);
    formData.append('swbNumber',fileCacheReq.swbNumber);
    return this.http.post<FileCacheWAResponse>(this.aglAPIs.fileCacheWithoutAcc.postRequest,formData,{withCredentials:true}).pipe(retry(3));

  }

  updateHardwareRelationshipMapping(hrmUpdateReq:HardwareRelationshipUpdateRequest){
    const headers = { 'content-type': 'application/json'}
    hrmUpdateReq.userName = this.urlParams.userName;
    hrmUpdateReq.changeNumber = this.urlParams.changeNumber;
    return this.http.post<boolean>(this.aglAPIs.updateHardwareRelMapping.postRequest,hrmUpdateReq,{'headers':headers,withCredentials:true}).pipe(retry(3));
  }

  getPartAttributeInfo(partNumber:string){
    const headers = { 'content-type': 'application/json'}
    return this.http.get<ItemInfoModel>(this.aglAPIs.getItemAttributes.getRequest,{'headers':headers,withCredentials:true, params:{partNumber:partNumber,userName:this.urlParams.userName}}).pipe(retry(3));
  }

  getUserGuides(){
    const headers = { 'content-type': 'application/json'}
    return this.http.get<string[]>(this.aglAPIs.getUserGuidesList.getRequest,{'headers':headers,withCredentials:true}).pipe(retry(3));
  }

  downloadUserGuide(fileName:string){



    console.log('Test2')

    return this.http.get(this.aglAPIs.downloadUserGuide.postRequest, {params:{fileName:fileName},responseType:'blob'}).pipe(retry(3));

  }

  checkRemoteFile(agileFileUploadReq:AgileFileUploadRequest)
  {
    const headers = { 'content-type': 'application/json'}
    return this.http.post<boolean>(this.aglAPIs.checkRemoteFile.getRequest,agileFileUploadReq,{'headers':headers,withCredentials:true}).pipe(retry(3));
  }

  // checkRemoteFile_V2(filePath:string,fileName:string,server:number)
  // {
  //   const headers = { 'content-type': 'application/json'}
  //   return this.http.get<boolean>(this.aglAPIs.checkRemoteFile.getRequest,agileFileUploadReq,{'headers':headers,withCredentials:true}).pipe(retry(3));
  // }
}
